// extracted by mini-css-extract-plugin
export default {"RubriqueNavigation":"RubriqueNavigationAdmin_RubriqueNavigation__dvCG2","active":"RubriqueNavigationAdmin_active__jcbNH"};